export default {
  navContainer: ({ props }) => ({
    class: [
      // Position
      'relative',

      // Misc
      { 'overflow-hidden': props.scrollable }
    ]
  }),
  navContent: {
    class: [
      // Overflow and Scrolling
      'overflow-y-hidden overscroll-contain',
      'overscroll-auto',
      'scroll-smooth',
      // The standard property wins over ::-webkit-scrollbar once `scrollbar-width` is set globally
      '[scrollbar-width:none]',
      '[&::-webkit-scrollbar]:hidden'
    ]
  },
  previousButton: {
    class: [
      // Flexbox and Alignment
      'flex items-center justify-center',

      // Position
      '!absolute',
      'top-0 left-0',
      'z-20',

      // Size and Shape
      'h-full w-12',
      'rounded-none',

      // Colors
      'bg-secondary-0 dark:bg-secondary-800',
      'text-primary-500 dark:text-primary-400',
      'shadow-md',

      // Icon weight (chevron is a filled path; add a matching-color stroke to thicken it)
      '[&_svg_path]:stroke-current [&_svg_path]:[stroke-width:0.75]'
    ]
  },
  nextButton: {
    class: [
      // Flexbox and Alignment
      'flex items-center justify-center',

      // Position
      '!absolute',
      'top-0 right-0',
      'z-20',

      // Size and Shape
      'h-full w-12',
      'rounded-none',

      // Colors
      'bg-secondary-0 dark:bg-secondary-800',
      'text-primary-500 dark:text-primary-400',
      'shadow-md',

      // Icon weight (chevron is a filled path; add a matching-color stroke to thicken it)
      '[&_svg_path]:stroke-current [&_svg_path]:[stroke-width:0.75]'
    ]
  },
  nav: {
    class: [
      // Flexbox
      'flex flex-1',

      // Spacing
      'list-none',
      'p-0 m-0',

      // Colors
      'bg-secondary-0 dark:bg-secondary-800',
      'border-b-2 border-secondary-200 dark:border-secondary-700',
      'text-secondary-900 dark:text-secondary-0/80'
    ]
  },
  tabpanel: {
    header: ({ props }) => ({
      class: [
        // Spacing
        'mr-0',

        // Misc
        {
          'opacity-60 cursor-default user-select-none select-none pointer-events-none': props?.disabled
        }
      ]
    }),
    headerAction: ({ parent, context }) => ({
      class: [
        'relative',

        // Font
        'font-bold',

        // Flexbox and Alignment
        'flex items-center',

        // Spacing
        'p-5',
        '-mb-[2px]',

        // Shape
        'border-b-2',
        'rounded-t-md',

        // Colors and Conditions
        {
          'border-secondary-200 dark:border-secondary-700': parent.state.d_activeIndex !== context.index,
          'bg-secondary-0 dark:bg-secondary-800': parent.state.d_activeIndex !== context.index,
          'text-secondary-700 dark:text-secondary-0/80': parent.state.d_activeIndex !== context.index,

          'bg-secondary-0 dark:bg-secondary-800': parent.state.d_activeIndex === context.index,
          'border-primary-500 dark:border-primary-400': parent.state.d_activeIndex === context.index,
          'text-primary-500 dark:text-primary-400': parent.state.d_activeIndex === context.index
        },

        // States
        'focus-visible:outline-none focus-visible:outline-offset-0 focus-visible:ring focus-visible:ring-inset',
        'focus-visible:ring-primary-400/50 dark:focus-visible:ring-primary-300/50',
        {
          'hover:bg-secondary-0 dark:hover:bg-secondary-800/80': parent.state.d_activeIndex !== context.index,
          'hover:border-secondary-400 dark:hover:border-primary-400': parent.state.d_activeIndex !== context.index,
          'hover:text-secondary-900 dark:hover:text-secondary-0': parent.state.d_activeIndex !== context.index
        },

        // Transitions
        'transition-all duration-200',

        // Misc
        'cursor-pointer select-none text-decoration-none',
        'overflow-hidden',
        'user-select-none'
      ]
    }),
    headerTitle: {
      class: [
        // Text
        'leading-none',
        'whitespace-nowrap'
      ]
    },
    content: {
      class: []
    }
  }
};
